module.exports = __webpack_public_path__ + "static/lady-justice-1b0fba795e8c03360f37ea9db29763a9.jpg";